function SvgKitchenAccess(props) {
  return (
    <svg viewBox="0 0 34 26" width="1em" height="1em" {...props}>
      <path
        d="M20.342 7.015a.749.749 0 00.756-.739v-3.7a.749.749 0 00-.756-.74.749.749 0 00-.756.74v3.7c0 .408.34.74.756.74m-3.415-.001a.749.749 0 00.756-.739V.739A.749.749 0 0016.927 0a.748.748 0 00-.756.74v5.536c0 .408.34.74.756.74m-3.415-.001a.749.749 0 00.756-.739v-3.7a.75.75 0 00-.756-.74.749.749 0 00-.756.74v3.7c0 .408.339.74.756.74M29.29 24.438H4.565a.749.749 0 00-.756.74c0 .407.34.739.756.739H29.29a.749.749 0 00.756-.74.75.75 0 00-.756-.739m.105-14.477c-.422 5.957-5.887 10.616-12.468 10.616-6.58 0-12.045-4.659-12.468-10.616h24.936zm3.704.31h-2.216c.031-.346.05-.696.05-1.05a.747.747 0 00-.755-.738H3.677a.749.749 0 00-.756.739c0 .353.02.703.05 1.05H.756A.749.749 0 000 11.01c0 .408.34.74.756.74h2.439c1.285 5.87 6.953 10.305 13.732 10.305 6.78 0 12.448-4.436 13.733-10.305h2.439a.749.749 0 00.756-.74.75.75 0 00-.756-.739z"
      />
    </svg>
  );
}

export default SvgKitchenAccess;
